import { useEffect, useState } from "react";
import styled from "styled-components";
import Product from "./Product";
import axios from 'axios';
import { mobile, zoomed } from "../responsive";
import { Link } from "react-router-dom";
import { BASE_URL, publicRequest } from "../api/axios";
import Course from "./Course";

const Container = styled.div`
    margin: 5vh 10vw;
    display: flex;
    flex-wrap: wrap;
    gap: 40px 0px;
    justify-content: space-around;
    ${zoomed({margin: '5vh 5vw'})}
`

const ProductsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  ${mobile({ flexDirection: 'column', justifyContent: 'center', width: '100%' })}
`


const Button = styled.a`
  padding: 20px;
  background-color: #216E8C;
  color: #fff;
  margin: 20px 0px;
  font-size: 16px;
  cursor: pointer;
  text-decoration: none;
  border: 2px solid transparent;

  &:hover {
    background-color: #fff;
    border: 2px solid #216E8C;
    color: #216E8C;
  }
`

const LastestCourses = ({}) => {
  
  
  const [courses, setCourses] = useState([]);

  
  useEffect(() => {
    const getCourses = async () => {
      try {
        const res = await publicRequest.get('/courses')
        setCourses(res.data)
      } catch (err) {
        console.log(err);
      }
    }
    getCourses();
  }, []);
console.log(courses)

  return (
    <Container>
      <ProductsContainer>
        {courses
          ?.slice() // importante → clona el array
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          .slice(0, 4)
          .map(item => (
            <Course item={item} key={item._id} />
          ))
        }
      </ProductsContainer>
      <Button  href={`https://cursos.lanuderia.com`} target="_blank" rel="noopener noreferrer">VER MAS CURSOS</Button>
    </Container>
  )

}

export default LastestCourses;